import $ from 'jquery';
import { CountUp } from "countup.js";

$(document).ready(function() {
    $(window).on('load scroll', function () {
        $('.statCard').each(function (index, element) {
            const $element = $(element);
            const $number = $element.find('.statCard__number');
            if ( $element.hasClass('counted') || $element.offset().top > $(window).scrollTop() + $(window).height() - 100 ) {
                return;
            }
            const endValue = $number.text();
            $number.text('0');
            const options = {
                endVal: endValue,
                duration: 2,
                useEasing: true,
                useGrouping: true,
                separator: ' ',
                decimal: $('html').attr('lang') === 'fr-CA' ? ',' : '.',
                decimalPlaces: endValue.includes('.') ? 1 : 0
            };
            const countUp = new CountUp($number[0], endValue, options);
            if (!countUp.error) {
                countUp.start();
                $element.addClass('counted');
            } else {
                console.error(countUp.error);
            }
        });


        $('.homeStatList__item').each(function (index, element) {
            const $element = $(element);
            const $number = $element.find('.homeStatList__number');
            if ( $element.hasClass('counted') || $element.offset().top > $(window).scrollTop() + $(window).height() - 100 ) {
                return;
            }
            const endValue = $number.text();
            $number.text('0');
            const options = {
                endVal: endValue,
                duration: 2,
                useEasing: true,
                useGrouping: true,
                separator: ' ',
                decimal: $('html').attr('lang') === 'fr-CA' ? ',' : '.',
                decimalPlaces: endValue.includes('.') ? 1 : 0
            };
            const countUp = new CountUp($number[0], endValue, options);
            if (!countUp.error) {
                countUp.start();
                $element.addClass('counted');
            } else {
                console.error(countUp.error);
            }
        });
    });
});